import React from 'react';
import styled from 'styled-components';
import Link from 'next/link';
import SVGIcons from './SVGIcons';
import useUserLogged from '../hooks/useUserLogged';

const DivAuthButton = styled.div`
    display: flex;
    align-items: center;
    
    @media only screen and (max-width: 1200px) {
        margin: 15px;
    }
`;

const BtnUser = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 3px;
`;

const UserProfile = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 100%;
    background-color: #156498;
    width: 36px;
    height: 36px;
    
    &:hover {
        background-color: #3ea78d;
    }
`;

const AuthButton = styled.button`
    position: relative;
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 23px;
    width: 74px;
    padding: 10px 20px 10px 0;
    margin-left: 20px;
    text-align: left;
    color: #000;
    font-size: 14px;
    font-weight: bold;
    background: transparent;
    border: none;
    border-radius: 0;
    border-bottom: 2px solid #000;
    gap: 3px;
    transition: 0.2s all;
    
    @media only screen and (max-width: 1200px) {
        margin-left: 0;
    }
    
    &:hover {
        color: #909394;
        border-bottom: 2px solid #909394;
    }
`;

const BtnSignIn: React.FC = () => {
  const [hover, setHover] = React.useState(false);
  const { isLogged, userData } = useUserLogged();

  return (
    <DivAuthButton>
      { !isLogged && (
        <Link href="https://www.webproject.com.br/login/" passHref>
          <AuthButton id="sign-in" onMouseEnter={() => setHover(true)} onMouseLeave={() => setHover(false)}>
            ENTRAR
            <SVGIcons type='SIGN_IN' width={16} height={16} fill={hover ? '#909394' : 'black'} />
          </AuthButton>
        </Link>
      )}

      { isLogged && (
        <Link href="https://www.webproject.com.br/home" passHref>
        <BtnUser onMouseEnter={() => setHover(true)} onMouseLeave={() => setHover(false)}>
          <UserProfile>
          {!userData?.picture30x30 && (
            <SVGIcons type='USER_ICON' width={30} height={30} fill={hover ? '#fff' : '#fafafa'} />
          )}
          {userData?.picture30x30 && <img src={userData?.picture30x30} alt={userData?.name} />}
          </UserProfile>
          <SVGIcons type='USER_ICON' width={25} height={25} fill={hover ? '#909394' : 'black'} />
        </BtnUser>
      </Link>
      )}

    </DivAuthButton>
  );
};

export default BtnSignIn;